import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import ReactToolTip from 'react-tooltip'

import Dollar from '../../../templates/Dollars/Dollars'
import Campaign from '../../../templates/Campaign/Campaign'
import { debounce } from '../../../assets/JS/functions'

// TODO: style the tooltip

const EarningsTable = (props) => {
    const { target, affiliateId, advertiserId, startDate, endDate, totals } = props

    const [stats, setStats] = useState(props.stats)
    const [searchText, setSearchText] = useState('')

    useEffect(() => {
        search()
    }, [searchText])

    const search = () => {

        let matchingArray = props.stats.filter(stat => (stat.campaign.name.toLowerCase().includes(searchText) || stat.campaign.id.toString() === searchText))

        setStats(matchingArray)
    }

    return (
        <div className="table-container-scroll">
            <ReactToolTip place="bottom" />
            <table className="table table-striped table-card m-0">
                <thead>
                    <tr>
                        <th scope="col">
                            <div className='d-flex align-items-center'>
                                <span>Campaign</span>
                                <span className="ml-2"><input type="text"
                                    placeholder="search..." className="form-control form-control-sm"
                                    onChange={debounce((e) => setSearchText(e.target.value), 300)}
                                /></span>
                            </div>
                        </th>
                        <th scope="col" className="text-right">
                            Clicks
                        </th>
                        <th scope="col" className="text-right">
                            Leads
                        </th>
                        {/* <th scope="col" className="text-right">
                                Net Earn.
                            </th> */}
                        <th scope="col" className="text-right">
                            {affiliateId ? 'Aff Earn.' : 'Net Earn.'}
                        </th>
                        <th scope="col" className="text-right">
                            Margin
                        </th>
                        <th></th>
                    </tr>
                </thead>
                {!stats || stats.length === 0 ? (
                    <div className="p-2">No stats available</div>
                ) : (
                    <tbody>
                        {totals && <tr className='font-weight-bold'>
                            <td>Totals</td>
                            <td className='text-right'>{Intl.NumberFormat('en-GB').format(totals[1].value)}</td>
                            <td className='text-right'>{Intl.NumberFormat('en-GB').format(totals[2].value)}</td>
                            <td className='text-right'><Dollar value={affiliateId ? totals[5].value : totals[4].value} /></td>
                            <td className='text-right'><Dollar value={totals[7].value} /></td>
                            <td></td>
                        </tr>}

                        {stats.map((stat, index) => (
                            <tr key={stat.campaign.id}>
                                <td>
                                    <Campaign oid={stat.campaign.id} name={stat.campaign.name} status={stat.campaign.status.value} affiliateStatus={stat.affiliate_status} affiliateId={affiliateId} />
                                </td>
                                <td className="text-right">
                                    <Link to={target === 'affiliate' ? `/reports/stats/daily?affiliateId=${affiliateId}&campaignId=${stat.campaign.id}&startDate=${startDate}&endDate=${endDate}&navigation=affiliate&withAvatar=true` : `/reports/stats/daily?advertiserId=${advertiserId}&campaignId=${stat.campaign.id}&startDate=${startDate}&endDate=${endDate}&navigation=advertiser&withAvatar=true`}>{Intl.NumberFormat('en-GB').format(stat.clicks)}</Link>
                                </td>
                                <td className="text-right">
                                    <Link to={target === 'affiliate' ? `/reports/stats/conversions?affiliateId=${affiliateId}&campaignId=${stat.campaign.id}&startDate=${startDate}&endDate=${endDate}&navigation=affiliate&withAvatar=true` : `/reports/stats/conversions?advertiserId=${advertiserId}&campaignId=${stat.campaign.id}&startDate=${startDate}&endDate=${endDate}&navigation=advertiser&withAvatar=true`}>{Intl.NumberFormat('en-GB').format(stat.conversions)}</Link>
                                </td>
                                {/* <td className="text-right">{<Dollar value={stat.network_earnings} />}</td> */}
                                <td className="text-right" data-tip={`EPC=$${stat.epc.toFixed(2)}`}>
                                    {<Dollar value={affiliateId ? stat.affiliate_earnings : stat.network_earnings} />}
                                </td>
                                <td className="text-right">
                                    <Link to={target === 'affiliate' ? `/reports/stats/campaigns?affiliateId=${affiliateId}&campaignId=${stat.campaign.id}&startDate=${startDate}&endDate=${endDate}&navigation=affiliate&withAvatar=true` : `/reports/stats/affiliates?advertiserId=${advertiserId}&campaignId=${stat.campaign.id}&startDate=${startDate}&endDate=${endDate}&navigation=advertiser&withAvatar=true`}>
                                        <Dollar value={stat.margin} />
                                    </Link>
                                </td>
                                <td></td>
                            </tr>
                        ))}
                    </tbody>
                )}
            </table>
        </div>
    )
}

export default EarningsTable
